/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArticleModel } from './ArticleModel';
import {
    ArticleModelFromJSON,
    ArticleModelFromJSONTyped,
    ArticleModelToJSON,
} from './ArticleModel';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { Html } from './Html';
import { HtmlFromJSON, HtmlFromJSONTyped, HtmlToJSON } from './Html';

/**
 *
 * @export
 * @interface ResponseGetArticleApiV1ArticlesArticleGet
 */
export interface ResponseGetArticleApiV1ArticlesArticleGet {
    /**
     *
     * @type {any}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    id: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    title: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    content: any | null;
    /**
     *
     * @type {Html}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    html: string;
    /**
     *
     * @type {any}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    type: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    author: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    publishOn: any | null;
    /**
     *
     * @type {FileUrl}
     * @memberof ResponseGetArticleApiV1ArticlesArticleGet
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ResponseGetArticleApiV1ArticlesArticleGet interface.
 */
export function instanceOfResponseGetArticleApiV1ArticlesArticleGet(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('content' in value)) return false;
    if (!('html' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    if (!('publishOn' in value)) return false;
    return true;
}

export function ResponseGetArticleApiV1ArticlesArticleGetFromJSON(
    json: any,
): ResponseGetArticleApiV1ArticlesArticleGet {
    return ResponseGetArticleApiV1ArticlesArticleGetFromJSONTyped(json, false);
}

export function ResponseGetArticleApiV1ArticlesArticleGetFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ResponseGetArticleApiV1ArticlesArticleGet {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        content: json['content'],
        html: json['html'],
        type: json['type'],
        author: json['author'],
        publishOn: json['publish_on'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ResponseGetArticleApiV1ArticlesArticleGetToJSON(
    value?: ResponseGetArticleApiV1ArticlesArticleGet | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        content: value['content'],
        html: HtmlToJSON(value['html']),
        type: value['type'],
        author: value['author'],
        publish_on: value['publishOn'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
